import { createContext, useState } from "react";

export const UIContext = createContext(null);

export const UIProvider = ({ children }) => {
  const [isBackgroundLocked, setIsBackgroundLocked] = useState(false);

  return (
    <UIContext.Provider
      value={{ isBackgroundLocked, setIsBackgroundLocked }}
    >
      {children}
    </UIContext.Provider>
  );
};